import Vue from "vue"
import vueResource from "vue-resource"
Vue.use(vueResource)

const baseUrl = process.env.API_ROOT;
Vue.http.options.emulateJSON = true;
Vue.http.interceptors.push((request, next) => {
	var TOKEN = sessionStorage.getItem('token') || '';
	request.headers.set('token', TOKEN);
	//配置请求头
	next((response) => {
		if (!response) {
			//do something when response
		}
		return response;
	});
});

export function post(url, params,headers_is) {
	return new Promise((resolve, reject) => {
		var TokenId=sessionStorage.getItem('TokenId') || '';
		if (TokenId) {
			params['TokenId']=TokenId;
		}
		// console.log(baseUrl)
		Vue.http.post(baseUrl + url, params).then(res => {
			if (res.status == 200) {
				if (res.body.status == 200) {
					resolve(res.body.data);
				}else if(res.body.status == 401){
					sessionStorage.removeItem('token');
					this.$router.push('/login');
				} else {
					this.$message.error(res.body.message);
				}
			} else if(res.status == 0) {
				sessionStorage.removeItem('token');
				this.$router.push('/login');
			} else {
				this.$message.error('请检查网络');
			}
		}).catch((err) => {
			console.log(err)
			reject(err);
		});
	});
}
export function get(url) {
	return new Promise((resolve, reject) => {
		Vue.http.get(baseUrl + url, ) .then((res) => {
			if (res.status == 200) {
				if (res.body.status == 200) {
					resolve(res.body.data);
				} else {
					this.$message.error(res.body.message);
				}
			} else {
				this.$message.error('请检查网络');
			}
		}) .catch((err) => {
			reject(err);
		});
	});
}



//////////////////
// WEBPACK FOOTER
// ./store/vue_resource.js
// module id = null
// module chunks = 